
export const AnimSpeed = {
	fast: '150ms',
	fastInt: 150,
	default: '300ms',
	defaultInt: 300,
	slow: '500ms',
	slowInt: 500,
};
